import {Component, OnDestroy, OnInit} from '@angular/core';
import {SpeechToTextService} from '../../../services/speech-to-text/speech-to-text.service';

@Component({
  selector: 'app-speech-to-text',
  templateUrl: './speech-to-text.component.html',
  styleUrls: ['../../../app.component.scss', './speech-to-text.component.scss']
})
export class SpeechToTextComponent implements OnInit, OnDestroy {
  finalSpan: any;
  constructor(public speechService: SpeechToTextService) {
  }

  ngOnInit() {
    setTimeout(() => {
      this.initSpeech();
    }, 100); // Needed a little bit delay
  }

  ngOnDestroy(): void {
    if (this.speechService.supportSpeech()) {
      this.speechService.stop();
    }
  }

  initSpeech() {
    const resultsDiv = document.getElementById('results') as any;
    this.finalSpan = document.getElementById('final_span') as any;
    const interimSpan = document.getElementById('interim_span') as any;

    this.speechService.onUpdateSpeechText = (finalTranscript: string, interimTranscript: string) => {
      resultsDiv.style.visibility = 'visible';
      this.finalSpan.innerHTML = this.speechService.linebreak(finalTranscript);
      interimSpan.innerHTML = this.speechService.linebreak(interimTranscript);
    };
    const startImg = document.getElementById('start_img') as any;
    this.speechService.onUpdateImage = (imgUrl: string) => {
      startImg.src = imgUrl;
    };
    const infoDiv = document.getElementById('info') as any;
    this.speechService.onUpdateInfo = (infoText: string, classes: any) => {
      infoDiv.innerHTML = infoText;
      infoDiv.classList = [];
      for (const cl of classes) {
        infoDiv.classList.add(cl);
      }
    };

    this.speechService.init();
  }

  public start() {
    this.speechService.start();

  }

  public save() {
    if (this.speechService.finalTranscript.length === 0) {
      alert('No text found');
    } else {
      const date = new Date();
      this.download('CBML_speech_to_text_' + date.toISOString() + '.txt', this.finalSpan.textContent);
    }
  }

  download(filename: string, text: string) {
    const element = document.createElement('a');
    element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
    element.setAttribute('download', filename);
    element.style.display = 'none';
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  }

  public copy() {
    const textArea = document.createElement('textarea');
    textArea.value = this.finalSpan.textContent;
    document.body.appendChild(textArea);
    textArea.select();
    document.execCommand('Copy');
    textArea.remove();
  }
}
